/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React from 'react'
import global from '../global_cal_style.module.scss'
import styles from './styles.module.scss'
import { arrayOfTimesGeneral, generateTimeSpanArray, isCurrentTimeInRange, splitMMDD, thisWeekGenerator } from '../timeLines'
import { ReactComponent as ClockIcon } from '../../../../assets/icons/clock-icon.svg'
import { ReactComponent as AddIcon } from '../../../../assets/icons/plus-ico.svg'
import AptMiniCard from '../AptMiniCard'
import { useSelector } from 'react-redux'

// Function to capitalize first letter of each word
const capitalizeWords = (text) => {
  if (!text) return text
  return text.split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ')
}

// Function to deduplicate appointments by patient when they have same date and time
const deduplicateAppointmentsByPatient = (appointments) => {
  const patientTimeMap = new Map()
  
  appointments.forEach(appointment => {
    const key = `${appointment.patient_id}-${appointment.date}-${appointment.from}-${appointment.to}`
    
    if (!patientTimeMap.has(key)) {
      patientTimeMap.set(key, appointment)
    } else {
      // If duplicate exists, keep the first appointment and ignore duplicates
      // console.log(`Duplicate appointment found for patient ${appointment.patient_id} at ${appointment.date} ${appointment.from}-${appointment.to}`)
    }
  })
  
  return Array.from(patientTimeMap.values())
}

const VerticalTable = ({ t, create, appointmentsArray, handleEditApt, selectedDate }) => {
  // Filter out fast service appointments
  const filteredAppointments = appointmentsArray.filter(app => !app.is_fast_service);
  // Deduplicate appointments before processing
  const deduplicatedAppointments = deduplicateAppointmentsByPatient(filteredAppointments)
  
  const fullArray = []
  const thisWeek = thisWeekGenerator(selectedDate)
  thisWeek.forEach((date) => {
    const todaysAppointments = deduplicatedAppointments.filter((appointment) => appointment.date === date.fullDate)
    const arrayOfspanTimes = generateTimeSpanArray(arrayOfTimesGeneral, todaysAppointments)
    fullArray.push(arrayOfspanTimes)
  })
  let tdSkipsMatrix = [[], [], [], [], [], [], []]
  const newDate = new Date()
  const users = useSelector(state => state.users?.users || [])

  return (
    <table className={global.schedule_table}>
      <thead>
        <tr>
          <th className={global.header_cell}>
            <ClockIcon className={global.clock_icon} />
          </th>
          {thisWeek.map((date, index) => {
            const { isToday, day, fullDate } = date
            return (
              <th key={index} className={`${global.header_cell} ${isToday ? global.today : ''}`}>
                <div className={global.day_info_wrap}>
                  <span className={global.day_text}>{day}</span>
                  <span className={global.date_text}>{splitMMDD(fullDate)}</span>
                </div>
              </th>
            )
          })}
        </tr>
      </thead>
      <tbody>
        {arrayOfTimesGeneral.map((time, indexTime) => {
          const { displayValue, value } = time
          const isGoing = isCurrentTimeInRange(newDate, displayValue, arrayOfTimesGeneral[indexTime + 1]?.displayValue)
          return (
            <tr key={displayValue}>
              <td className={`${global.day_cell} ${isGoing ? global.going_now : ''}`}>{displayValue}</td>
              {thisWeek.map((day, index) => {
                if (tdSkipsMatrix[index].includes(indexTime)) {
                  return null
                }
                const { isToday } = day
                const thisDay = fullArray[index]
                const group = thisDay?.find((group) => group?.from === value)
                const { fullspan, appointments } = group || {}
                if (appointments?.length > 0) {
                  if (fullspan > 1) {
                    for (let i = 0; i < fullspan; i++) {
                      tdSkipsMatrix[index].push(indexTime + i)
                    }
                  }
                  return (
                    <td key={index} rowSpan={fullspan || 1} className={`${global.td_cell} ${isToday ? global.today : ''}`}>
                      <div
                        key={index}
                        className={styles.appointments_container_vertical}
                        onClick={() => create({ time: { from: time.value }, date: day })}
                        style={{
                          height: `${Math.max(fullspan * 110, appointments.length * 55 + 80)}px`
                        }}
                      >
                        {appointments.map((appointmentId, index) => {
                          const appointmentData = deduplicatedAppointments.find((appointment) => appointment.id === appointmentId)
                          const { name, patient_name, from, to, color, is_paid, doctor_id } = appointmentData || {}
                          const doctor = users.find(user => user.id === doctor_id)
                          return (
                            <div key={appointmentId} className={styles.appointment_container_vertical}>
                              <div
                                className={styles.appointment}
                                style={{
                                  top: `${(((from - value) * 2) / fullspan) * 100}%`,
                                  height: `${(((to - from) * 2) / fullspan) * 100}%`,
                                  backgroundColor: doctor?.color || color || 'gray',
                                  border: is_paid ? '2px solid black' : '2px solid transparent'
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  handleEditApt(appointmentData)
                                }}
                              >
                                <div className={styles.apt_details}>
                                  <span className={styles.time}>{capitalizeWords(patient_name || name)}</span>
                                  {/* <span className={styles.description}>{description}</span> */}
                                </div>
                                <div className={`${global.apt_mini_card} ${styles.apt_mini_card}`}>
                                  <AptMiniCard t={t} card={appointmentData} />
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </td>
                  )
                } else {
                  return (
                    <td key={index} className={`${global.td_cell} ${isToday ? global.today : ''}`}>
                      <div className={global.empty_apt_container}>
                        <button className={global.add_button} onClick={() => create({ time: { from: time.value }, date: day })}>
                          <AddIcon />
                        </button>
                      </div>
                    </td>
                  )
                }
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default VerticalTable
